import { Paragraph } from "@tiptap/extension-paragraph";

const ParagraphExtended = Paragraph.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      stylePreferences: {},
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    const stylePrefs = this.options.stylePreferences;
    let styleString = stylePrefs["p"] || '';

    if (node.attrs.textAlign && node.attrs.textAlign !== 'left') {
      const textAlignStyle = `text-align: ${node.attrs.textAlign}`;
      styleString = styleString ? `${styleString}; ${textAlignStyle}` : textAlignStyle;
    }

    if (styleString) {
      HTMLAttributes.style = styleString;
    }

    return this.parent?.({ node, HTMLAttributes });
  },
})

export default ParagraphExtended;
